import styled from "styled-components";

export const CardWrapper = styled.div`
  width: 299px;
  height: 315px;
  border-radius: 8px;
  position: relative;
  background: ${({ background }) => (background ? background : "#fff")};
  box-shadow: 0px 4px 10px 0px #0000000a;
  .slice-text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  & .card-header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 36px;
    padding: 10px 16px;
    font-weight: 500;
    font-size: 15px;
    color: #343c6a;
  }
  .dotsWrap {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    border: none;
    outline: none;
    background: none;
  }

  & .three-dots {
    cursor: pointer;
    color: #8490a5;
    font-size: 22px;
  }
  .image-wrapper img {
    width: 100%;
    object-fit: cover;
    height: 187px;
  }
  & .image-wrapper {
    width: 100%;
    height: 187px;
    position: relative;

    .ant-carousel .slick-prev {
      left: 20px;
      top: 45%;
      position: absolute;
      z-index: 10000;
      background-color: rgb(58 58 61 / 62%);
      font-size: 20px;
      color: white;
      width: 32px;
      height: 32px;
      padding: 8px;
      border-radius: 50%;
    }
    .ant-carousel .slick-next {
      top: 45%;
      right: 20px;
      position: absolute;
      z-index: 10000;
      background-color: rgb(58 58 61 / 62%);
      font-size: 20px;
      color: white;
      width: 32px;
      height: 32px;
      padding: 8px;
      border-radius: 50%;
    }
  }

  & .card-title {
    width: 100%;
    margin-top: 12px;
    color: #343c6a;
    font-size: 16px;
    line-height: 20.8px;
    font-weight: 500;
    padding-left: 16px;
    padding-right: 20px;
    word-wrap: break-word;
    cursor: pointer;
  }

  & .card-date-and-views {
    display: flex;
    gap: 20px;
    padding-left: 16px;
    padding-bottom: 16px;
  }

  & .innner-date-and-view {
    display: flex;
    align-items: center;
    gap: 5px;
    padding-top: 12px;
    font-size: 12px;
    font-weight: 500;
    line-height: 12px;
    color: #8490a5;
  }
`;

export const ThreeDotsContainer = styled.div`
  position: absolute;
  right: 0;
  top: 36px;
  z-index: 1;
  width: 100px;
  height: 50px;
  font-size: 13px;
  font-weight: 500;
  background-color: #fff;
  color: #343c6a;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 7px 10px;
  cursor: pointer;
  box-shadow: 0px 0px 10px #cececf;
`;

export const UpdateIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  :hover {
    color: var(--sidebar-item-active);
  }
`;

export const DeleteIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  :hover {
    color: red;
  }
`;
